<template>
  <div class="page-with-top-bar">
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="boxes"></b-icon>
              <span> {{ $t('stock_warehouse') }} </span>
            </template>
            <stock-warehouse :projectId="project_id" />
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="clipboard-list"></b-icon>
              <span> {{ $t('inputs') }} </span>
            </template>
            <warehouse-packing-list :projectId="project_id" />
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="arrow-right-from-bracket"></b-icon>
              <span> {{ $t('outputs') }} </span>
            </template>
            <warehouse-outputs :project-id="project_id" />
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="undo"></b-icon>
              <span> {{ $t('returns') }} </span>
            </template>
            <warehouse-returns :project-id="project_id" />
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="cubes"></b-icon>
              <span> {{ $t('materials') }} </span>
            </template>
            <warehouse-materials :project-id="project_id" />
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="truck"></b-icon>
              <span> {{ $t('providers') }} </span>
            </template>
            <warehouse-providers :project-id="project_id" />
          </b-tab-item>
        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StockWarehouse from './warehouse/stock-warehouse.vue'
import WarehouseOutputs from './warehouse/warehouse-outputs.vue'
import WarehouseReturns from './warehouse/warehouse-returns.vue'
import WarehousePackingList from './warehouse/warehouse-packing-list.vue'
import WarehouseProviders from '../admin/warehouse/warehouse-providers.vue'
import WarehouseMaterials from '../admin/warehouse/warehouse-materials.vue'

export default {
  name: 'project-warehouse',
  middleware: 'auth',
  title: 'storehouse_page_title',
  subtitle: 'storehouse_page_subtitle',
  menuOption: '2-10',
  components: {
    StockWarehouse,
    WarehouseOutputs,
    WarehouseReturns,
    WarehousePackingList,
    WarehouseProviders,
    WarehouseMaterials,
  },
  computed: {
    ...mapGetters({
      project: 'app/project',
    }),
  },
  data: () => ({
    project_id: null,
    mainActiveTab: 0,
  }),
  created() {
    this.project_id = this.project.id

    // Si no está activado Warehouse v2, volvemos a la ruta clásica.
    if (Number(this.project && this.project.warehouse_type) !== 1) {
      this.$router.replace({ name: 'project.storehouse' })
    }
  },
}
</script>

